import { createContext } from "react";

const BrokerIncentiveContext = createContext({});

export default BrokerIncentiveContext;
